import { useStyletron } from 'parkdepot-shared/theme'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

// routes
import { homeRoute } from '../../views/Home/route.const'

// style components
import Icon from '../style/Icon.style'
import Text from '../style/Text.style'
import { Container, Back } from './BackRoute.style'

interface Props {
    onBackClick?: () => void
    mobile?: boolean
    $mobileNoImage?: boolean
    desktop?: boolean
    onlyIcon?: boolean
    className?: string
}

const BackRoute: FC<Props> = ({ onBackClick, mobile, $mobileNoImage, onlyIcon = false, className }) => {
    const [, theme] = useStyletron()
    const { t } = useTranslation()
    const history = useHistory()
    const location = useLocation()

    const onClick = () => {
        if (onBackClick) {
            onBackClick()
        } else if (location.key) {
            history.goBack()
        } else {
            history.push(homeRoute())
        }
    }

    return (
        <Container $mobile={mobile} $mobileNoImage={$mobileNoImage} className={className}>
            <Back onClick={onClick} className="minor-hover-effect" aria-label={t('common.back')}>
                <Icon
                    style={{ cursor: 'pointer' }}
                    className="wemolo-arrow-left"
                    fontWeight={600}
                    color={theme.colors.primary}
                    aria-hidden="true"
                    $size="large"
                />
                {(!mobile || $mobileNoImage) && !onlyIcon && (
                    <Text
                        fontWeight={500}
                        typography={$mobileNoImage ? theme.typography.ParagraphSmall : theme.typography.ParagraphMedium}
                    >
                        {t('common.back')}
                    </Text>
                )}
            </Back>
        </Container>
    )
}

export default BackRoute
